import React, { forwardRef, PropsWithChildren } from "react";
import PropTypes from "prop-types";

import LpgContinueSolid from "@/icons/Lpg/ContinueSolid";

import type { ReactComponentStaticProps } from "../../types/react";

import { TextLink, TextLinkProps } from "../TextLink";
import { EqualHeightElement } from "../EqualHeight/EqualHeightElement";

import styles from "./ContentTileNavigation.scss";

type NavTileLinkBaseProps = PropsWithChildren<{}> & {
  variants?: TextLinkProps["variants"];
  href: TextLinkProps["href"];
};
export type NavTileLinkProps = NavTileLinkBaseProps &
  Omit<React.ComponentPropsWithRef<"a">, keyof NavTileLinkBaseProps>;

const defaultVariants = [TextLink.Variant.highlight];

const defaultProps = {
  children: "",
  variants: defaultVariants,
} as const;

const NavTileLinkWithRef = (
  props: NavTileLinkProps,
  ref: React.ComponentPropsWithRef<"a">["ref"]
) => {
  const { href, children, variants, ...others } = props;
  return (
    <div className={styles.linkWrapper}>
      <EqualHeightElement name="navTileLink">
        <TextLink
          ref={ref}
          href={href}
          variants={variants}
          iconRight={LpgContinueSolid}
          rightIconProps={{
            style: { position: "absolute", top: 2, left: 2 },
          }}
          {...others}
        >
          {children}
        </TextLink>
      </EqualHeightElement>
    </div>
  );
};

export const NavTileLink = (forwardRef(NavTileLinkWithRef) as unknown) as ((
  props: NavTileLinkProps
) => ReturnType<typeof NavTileLinkWithRef>) &
  Required<ReactComponentStaticProps<NavTileLinkProps>>;

NavTileLink.propTypes = {
  href: PropTypes.string.isRequired,
  variants: TextLink.propTypes.variants,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

NavTileLink.defaultProps = defaultProps;

NavTileLink.displayName = "ContentTileNavigation.Item.Link";

export default NavTileLink;
